import LogsErrorsBlueprint from "./index"
import store from "../../store"
export default class AppLog {
    constructor({ name = null, message = null, ...rest }) {
        // send logLevel:'info' in the AppLog object whenever you want to log an info level log on Datadog
        if (isResponseAnalyzerEnabled()) {
            rest.logSource = "ResponseAnalyser";
        }
        let logErrorObj = new LogsErrorsBlueprint({name, message, ...rest})
        logErrorObj.sendLogs({ logLevel: 'info' })
    }
 }

 function isResponseAnalyzerEnabled () {
     return store?.getters?.isResponseAnalyzerEnabled
 }
